import TableHeader from '@/components/reusables/dashboard/TableHeader';
import { useFetchRecentQRScanActivity } from '@/hooks/dashboardHooks';
import { QrCode } from 'lucide-react';
import ProductQrRow from './ProductQrRow';
import { useNavigate } from 'react-router';

const RecentQRScanActivity = () => {
  const navigate = useNavigate();
  const { data: scanData } = useFetchRecentQRScanActivity();

  return (
    <>
      {
        <div className="d-full-card-wrap mb-0!">
          <TableHeader
            title="Recent QR Scan Activity"
            titleIcon={QrCode}
            onViewAllButtonClick={() => navigate('/owner/reports?tab=scanned-products')} // qr-scan-activity
            className="mb-4"
          />
          <div className="product-qr-row-wrap max-h-100 overflow-auto">
            {scanData && scanData?.length > 0 ? (
              scanData?.map((item: any, idx: any) => <ProductQrRow item={item} key={idx} />)
            ) : (
              <p className="text-center">No recent activity</p>
            )}
          </div>
        </div>
      }
    </>
  );
};

export default RecentQRScanActivity;
